import { CloseCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { Banner } from '@framework/ui/components/banner/Banner.tsx';
import clx from 'classnames';
import { useMemo } from 'react';
import styled from 'styled-components';
import { useCardinalityConstraintContext } from './CardinalityConstraintContext.tsx';
import { getCardinalityConstraintsViolations } from './getCardinalityConstraintsViolations.ts';
import { SubmissionCardinalityLogic } from './SubmissionCardinalityLogic.ts';

const BannerWrapper = styled.div`
  &.backoffice {
    margin-bottom: 24px;
  }
`;

interface IBanerCardinalityWarningProps {
  submission: RichiestaDTO | undefined;
  prefix?: string;
  isBackoffice?: boolean;
}

/**
 * Componente centralizzato per mostrare gli erorri/warning di cardinalità
 * di una richiesta FO e BO.
 */
export function BannerCardinalityWarning(props: IBanerCardinalityWarningProps) {
  const { submission, prefix, isBackoffice } = props;

  const { constraints } = useCardinalityConstraintContext();

  // Recupero i vincoli di cardinalità violati se presenti
  const cardinalityConstraintsViolations = useMemo(
    () => getCardinalityConstraintsViolations(submission, constraints),
    [constraints, submission],
  );

  if (
    SubmissionCardinalityLogic.hasViolation(cardinalityConstraintsViolations)
  ) {
    return (
      <BannerWrapper
        className={clx({
          backoffice: isBackoffice,
        })}
      >
        {cardinalityConstraintsViolations?.map(v => {
          const isError = v.livello === 'ERRORE';
          return (
            <Banner
              key={v.id}
              showIcon
              type={isError ? 'error' : 'warning'}
              icon={
                isError ? (
                  <CloseCircleOutlined aria-label="Error" />
                ) : (
                  <WarningOutlined aria-label="Warning" />
                )
              }
              content={(prefix ?? '') + v.descrizione}
            />
          );
        })}
      </BannerWrapper>
    );
  }

  return null;
}
